import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class BusyIndicatorService
{
    parentBusy: boolean;
    message: string;

    show(message: string = "Loading..."): void
    {
        this.message = message;
        this.parentBusy = true;
    }

    hide(): void
    {
        this.parentBusy = false;
    }
}
